import { SearchActionsEnum } from '../enums/SearchActionsEnum';
import { ISearchState } from '../interfaces/ISearchState';
import { SearchAction } from '../types/SearchAction';

const initialState: ISearchState = {
  string: '',
  resultsData: null,
  order: '',
  totalPages: 1,
  page: 1,
  total: 0,
  filter: {},
};

export function searchReducer(state = initialState, action: SearchAction): ISearchState {
  switch (action.type) {
    case SearchActionsEnum.SEARCH_RESET_PAGE: {
      return initialState;
    }
    case SearchActionsEnum.SEARCH_SET_SEARCH_STRING:
      return {
        ...state,
        searchString: action.payload.searchString,
      };
    case SearchActionsEnum.SEARCH_SET_RESULT_DATA: {
      const { content, totalPages, totalElements, number } = action.payload.resultsData;
      return {
        ...state,
        resultsData: content,
        totalPages,
        total: totalElements,
        page: number + 1,
      };
    }
    case SearchActionsEnum.SEARCH_SET_FILTER: {
      return {
        ...state,
        filter: action.payload.filter,
      };
    }
    case SearchActionsEnum.SEARCH_SET_FILTER_OPTIONS: {
      return {
        ...state,
        filterOptions: action.payload.filterOption,
      };
    }
    case SearchActionsEnum.SEARCH_SET_ORDER: {
      const newState: ISearchState = {
        ...state,
        order: action.payload.order,
      };
      return newState;
    }
    default:
      return state;
  }
}
